<template lang="pug">
.diagnosticModalCloseContent
  .title {{ title }}
  .actions
    ui-button(
      color="blue-outline"
      variant="3d"
      is-responsive
      @click="$emit('yes')"
    ) Да
    ui-button(
      color="blue"
      variant="3d"
      is-responsive
      @click="$emit('no')"
    ) Нет

</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  emits: ['yes', 'no']
}
</script>

<style lang="sass" scoped>
.diagnosticModalCloseContent
  width: 145*$u
  max-width: 100%
  display: flex
  flex-flow: column
  align-items: center
  z-index: $zIndexModal

  > .title
    @include font('h2')
    max-width: 130*$u
    text-align: center
    margin-bottom: 5*$u

  > .actions
    width: 40*$u
    display: grid
    grid-template-columns: repeat(2, 1fr)
    grid-gap: 6*$u

  @media screen and (max-width: $padWidth)
    width: auto

    > .title
      @include font('t20-demibold')

    > .actions
      width: fit-content

</style>
